import { render } from "./Usuarios.vue?vue&type=template&id=5b4ce49b&scoped=true"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"

import "./Usuarios.vue?vue&type=style&index=0&id=5b4ce49b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/central-front/central-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4ce49b"]])

export default __exports__